<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12">
                    <ValidationProvider name="user_id" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('members')">
                            <b-form-input
                                v-model="form.student_number+' '+form.name+' '+form.surname"
                                :disabled="true"
                                :validate-error="errors[0]"></b-form-input>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="status" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('status')">
                            <parameter-selectbox v-model="form.status" code="student_club_president_application_user_statuses" :validate-error="errors[0]"></parameter-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <b-button
                    @click="updateForm"
                    type="button"
                    :disabled="formLoading"
                    variant="primary"
                    class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </ValidationObserver>
    </div>
</template>

<script>
    //Component

    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import StudentClubService from "@/services/StudentClubService";
    import StudentsAutoComplete from "@/components/interactive-fields/StudentsAutoComplete.vue";

    export default {
        components: {
            StudentsAutoComplete,
            ValidationProvider,
            ValidationObserver,

        },
        props: {
            formId: {
                type: Number,
            }
        },
        data() {
            return {
                formLoading: false,
                selectedPresident: '',
                form: {
                    student_club_president_application_id: this.formId,
                    user_id: null,
                    status: null
                }
            }
        },
        watch: {
            formId: function (val) {
                this.get(val)
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                this.formLoading = true;
                StudentClubService.getPresidentUsers(id)
                               .then((response) => {
                                   this.form = response.data.data;
                                   this.formLoading = false;
                               })
                               .catch((error) => {
                                   if (error.data.message) {
                                       this.$toast.error(this.$t("api." + error.data.message));
                                   }
                               });
            },
            async updateForm() {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid && this.formId) {
                    this.formLoading = true;
                    StudentClubService.updatePresidentUsers(this.formId, this.form)
                                   .then((response) => {
                                       this.formLoading=false;
                                       this.$toast.success(this.$t("api." + response.data.message));
                                       this.$emit("updateFormSuccess")
                                   })
                                   .catch((error) => {
                                       this.showErrors(error, this.$refs.formModalValidate)
                                   })
                }
            },
            handleSelection(user) {
                this.form.user_id = user?.user_id;
                this.selectedPresident = user ? `${user.name} ${user.surname}` : '';
            }
        }
    }
</script>
